import SparkMD5 from 'spark-md5'
function getMD5(file,callback){
    var fileReader = new FileReader();
    // console.log(file)
    let MD5list = []
    var dataFile = file;
    const _this = this
    var spark = new SparkMD5(); //创建md5对象（基于SparkMD5）
    // fileReader.readAsBinaryString(dataFile);
    fileReader.readAsBinaryString(dataFile);

    //文件读取完毕之后的处理
    fileReader.onload = function(e) {
        spark.appendBinary(e.target.result);
        var md5 = spark.end()
        // console.log(md5)
        callback(md5)
        // _this.getMd5Checked(md5)
    };


    // for (let i = 0; i < file.length; i++) {
    //     var dataFile = file[i].raw;
    //     console.log(dataFile)
    //     const _this = this
    //     var spark = new SparkMD5(); //创建md5对象（基于SparkMD5）
    //     // fileReader.readAsBinaryString(dataFile);
    //     if (dataFile.size > 1024 * 1024*10) {
    //         var data1 = dataFile.slice(0, 1024 * 1024*10); //将文件进行分块 file.slice(start,length)
    //         fileReader.readAsBinaryString(data1); //将文件读取为二进制码
    //     } else {
    //         fileReader.readAsBinaryString(dataFile);
    //     }

    //     //文件读取完毕之后的处理
    //     fileReader.onload = function(e) {
    //         spark.appendBinary(e.target.result);
    //         var md5 = spark.end()
    //         MD5list.push(md5)
    //         // _this.getMd5Checked(md5)
    //     };
    // }
    
    // return MD5list
}

export default getMD5